var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      class: ["btn", _vm.buttonClass],
      staticStyle: { padding: "0.7em 2em" },
      attrs: {
        type: _vm.isFormSubmit ? "submit" : "button",
        disabled: _vm.isButtonDisabled,
      },
      on: { click: _vm.saveChanges },
    },
    [_vm._v("\n    " + _vm._s(_vm.buttonText) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }